export default "__VITE_ASSET__984f64e9__"